import { cleanOldRedirectPath } from '~/composables/cleanOldRedirectPath'

export function readCleanedRedirectCookie() {
  const { $lendioCookies } = useNuxtApp()
  let redirect = $lendioCookies.get('redirect')
  if (redirect) {
    redirect = redirect.startsWith('/') ? redirect : '/' + redirect
    redirect = cleanOldRedirectPath(redirect)
  }
  return redirect
}
